//TRANSITION DE PAGE
const link = document.querySelectorAll(".btn__anim");
const page = document.querySelector(".transition");

link.forEach((element) =>{
  element.addEventListener("click", function(e){

    //récupérer le href, stocker
    const currentLink = element.href;

    //ajouter class .animation au body
    page.classList.add("animation");

    //animation end du body
    page.addEventListener("animationend", function(){

      //active le lien (changement de page)
      window.location = currentLink;
      
    });

    e.preventDefault(); //un lien qui ne lien plus


  });
});

const herbe = document.querySelector(".ingredients__el--herbe");
const agrume = document.querySelector(".ingredients__el--agrume");
const sucre = document.querySelector(".ingredients__el--sucre");
const fruit = document.querySelector(".ingredients__el--fruit");
const liquide = document.querySelector(".ingredients__el--liquide");
const glace = document.querySelector(".ingredients__el--glace");

const accrocheRcette = document.querySelector(".accroche__small--recette");
const decouvrir = document.querySelector(".container--right");

animIngredient (decouvrir, "decouvrir__anim", "13");

animIngredient (herbe, "ingredients__anim--herbe", "30");
animIngredient (agrume, "ingredients__anim--agrume", "30");
animIngredient (sucre, "ingredients__anim--sucre", "30");
animIngredient (fruit, "ingredients__anim--fruit", "40");
animIngredient (liquide, "ingredients__anim--liquide", "40");
animIngredient (glace, "ingredients__anim--glace", "40");

animIngredient (accrocheRcette, "accroche__anim", "55");


function animIngredient (el, classe, scroll){
  window.addEventListener('scroll', function() {
    var scrollTop = window.scrollY;
    var windowHeight = window.innerHeight;
    var scrollHeight = document.body.scrollHeight;
     
    var scrollPercent = (scrollTop / (scrollHeight - windowHeight)) * 100;

    if (scrollPercent > scroll){
      el.classList.add(classe);

    }

  });
}